export const Status = {
  EMPTY: 'empty',
  ADDING: 'adding',
  BROWSING: 'browsing',
  EDITING: 'editing',
};

export const Accept = {
  Package:
    'application/zip, application/octet-stream, ' +
    'application/x-zip-compressed, multipart/x-zip',
  Assets:
    'video/3gpp, video/mp4, video/mpeg, video/ogg, ' +
    'video/quicktime, video/webm, video/x-m4v, ' +
    'video/ms-asf, video/x-ms-wmv, video/x-msvideo, ' +
    'audio/basic, auido/L24, audio/mid, audio/mpeg, ' +
    'audio/mp4, audio/x-aiff, audio/x-mpegurl, audio/*, ' +
    'audio/vnd.rn-realaudio, audio/ogg, audio/vorbis, ' +
    'audio/vnd.wav, text/html, image/jpeg, image/png, ' +
    'application/json, application/javascript, ' +
    'application/ecmascript, application/octet-stream',
  Image: 'image/jpeg, image/png',
};
